/** @jsxImportSource @emotion/react */

import { Typography, Box, useTheme, Button } from '@mui/material'
import { css } from '@emotion/react'
import { useNavigate } from 'react-router-dom'
import { appLink } from '@app/config/appLink'
import { useMap } from '@app/contexts/ModuleMapContexts/RiskMapContext'
import { FolderOpen } from 'lucide-react'
import { useLiveContext } from '@app/modules/Live/contexts/Live.Context'

export const ActiveWorkspaceHeader = () => {
  const theme = useTheme()
  const { activeWorkspace } = useMap()
  const navigate = useNavigate()
  const { liveMapSelected } = useLiveContext()

  return (
    <Box
      p={'12px 12px 12px 16px'}
      borderBottom={`1px solid ${theme.palette.uintel.main}20`}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography variant="h6" component="div" color={'primary'}>
        <Box display="flex" alignItems="center" gap={1}>
          <strong>{activeWorkspace ? activeWorkspace.name : 'Active layers'}</strong>
        </Box>
      </Typography>
      {!liveMapSelected && (
        <Button
          onClick={() => navigate(appLink.riskWorkspacesCreate.path)}
          variant="text"
          size="small"
          startIcon={
            <Box
              sx={{
                backgroundColor: theme.palette.blue.main,
                color: theme.palette.blue.contrastText,
                borderRadius: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '24px',
                height: '24px',
              }}
            >
              <FolderOpen size={16} />
            </Box>
          }
          color={'blue'}
          css={css`
            align-self: flex-end;
            margin-left: 8px;
            font-size: 14px;
          `}
        >
          Workspaces
        </Button>
      )}
    </Box>
  )
}
